import React from 'react';
import ChowaDashboardLayout from './config/ChowaDashboardLayout';
import { sidebarConfig } from './config/sidebarConfig';
import { ChowaThemeProvider } from './config/chowaThemeContext';
import ChowaMainDashboard from './dashboard/main/ChowaMainDashboard';
import TimeMonitoringSeriesSelection from './time-monitoring/TimeMonitoringSeriesSelection';
import HVSeriesPage from './time-monitoring/HVSeriesPage';
import SRSeriesPage from './time-monitoring/SRSeriesPage';
import ZVSeriesPage from './time-monitoring/ZVSeriesPage';
import TMSDetail from './TMS/TMSDetail';  // 新しい動的TMSコンポーネント
import UnitManagement from './UnitManagement/UnitManagement';  // ユニット管理

const routes = [
  // ダッシュボード（独立）
  {
    path: 'main',
    component: ChowaMainDashboard
  },
  // 時間監視のルート
  {
    path: 'time-monitoring',
    component: TimeMonitoringSeriesSelection
  },
  {
    path: 'time-monitoring/hv',
    component: HVSeriesPage
  },
  {
    path: 'time-monitoring/sr',
    component: SRSeriesPage
  },
  {
    path: 'time-monitoring/zv',
    component: ZVSeriesPage
  },
  // 動的TMSのルート（tms000, tms001などに対応）
  {
    path: 'tms/:modelId/*',  // 動的パラメータ
    component: TMSDetail     // 汎用TMSコンポーネント
  },
  // ユニット管理のルート
  {
    path: 'unit-management',
    component: UnitManagement
  }
];

const ChowaApp = () => {
  return (
    <ChowaThemeProvider>
      <div data-chowa-app>
        <ChowaDashboardLayout 
          routes={routes} 
          sidebarConfig={sidebarConfig}
        />
      </div>
    </ChowaThemeProvider>
  );
};

export default ChowaApp; 